import { useMatches } from 'react-router'

import { useQueryParams } from '@/hooks/use-query-params'

export function useRouteCompanyId() {
  const matches = useMatches()
  const companyIdFromPath = matches[matches.length - 1]?.params.companyId

  const { getQueryParams } = useQueryParams()
  const { companyId: companyIdFromQuery } = getQueryParams()

  return companyIdFromPath || companyIdFromQuery
}
